import { FlexibleModelBase, FlexibleBaseSpecification } from './flexible_base';
import type { OpenUrlWithKind } from '@api/generated/models';

export interface FlexibleButtonHyperlinkSpecification extends FlexibleBaseSpecification {
	id: number;
	title: string;
	url: string;
	requiresAuthentication: boolean;
	openAnotherApp: boolean;
	hasBrandedNavbar: boolean;
	openUrlWith: OpenUrlWithKind;
}

export class FlexibleButtonHyperlinkModel extends FlexibleModelBase {
	public readonly title: string;
	public readonly url: string;
	public readonly requiresAuthentication: boolean;
	public readonly openAnotherApp: boolean;
	public readonly hasBrandedNavbar: boolean;
	public readonly openUrlWith: OpenUrlWithKind;

	constructor(spec: FlexibleButtonHyperlinkSpecification) {
		super(spec);

		this.title = spec.title;
		this.url = spec.url;
		this.requiresAuthentication = spec.requiresAuthentication;
		this.openAnotherApp = spec.openAnotherApp;
		this.hasBrandedNavbar = spec.hasBrandedNavbar;
		this.openUrlWith = spec.openUrlWith;
	}
}
